import React, { FC } from 'react';

import { PageLayoutProps, PageLayoutWidth } from './PageLayout.types';
import { getClassNames } from './PageLayoutBanner.styles';

export interface PageLayoutBannerProps extends Pick<PageLayoutProps, 'onRenderBanner'> {
  readonly hasHeader?: boolean;
  readonly width: PageLayoutWidth | undefined;
}

const PageLayoutBanner: FC<PageLayoutBannerProps> = ({ hasHeader = false, width, onRenderBanner }) => {
  if (!onRenderBanner) {
    return null;
  }

  const { globalBanner } = getClassNames(hasHeader);

  return <div className={globalBanner}>{onRenderBanner(width)}</div>;
};

export default PageLayoutBanner;
